/* eslint-disable react/display-name */
import { TableColumnType, Col, Button, Popconfirm } from 'antd'
import React, { ReactElement } from 'react'
import { Dimen } from '../../models/dimen'
import { ThemeData } from '../../theme/ThemeContext'
import { Checks } from '../../models/setting'

export const Columns = (
  startIndex?: any,
  onDelete?: (text: any, t: any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, i) => `${startIndex + i + 1}`,
    },
    {
      title: '药品名称',
      align: 'center',
      key: 'drugName',
      dataIndex: 'drugName',
      ellipsis: true,
      render: (_, r) => {
        return r.drugName ? r.drugName : '-'
      },
    },
    {
      title: '预览内容',
      align: 'center',
      key: 'reminderContent',
      dataIndex: 'reminderContent',
      ellipsis: true,
      render: (_, r) => {
        return r.reminderContent ? r.reminderContent : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '90px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div>
            <Popconfirm
              title='确认此操作？'
              onConfirm={ () => {
                 onDelete && onDelete('delete', t)
              }}
              okText='确认'
              cancelText='取消'
            >
              <a style={{ color: 'red' }}>删除</a>
            </Popconfirm>
          </div>
        )
      },
    },
  ]
}

// 违规预警设置 多种药品 诊疗误配预警搜索
export const DrugSearchInput = (theme: ThemeData, flag?: number, settings?: any): TableColumnType<any>[] => {
  // 新老目录展示方式
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? item.model + '/' : ''
    const accountUnit = item.accountUnit ? item.accountUnit : '-'
    const spec = item.spec ? item.spec : '-'

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 包装规格 + 剂型 + 生产厂家
        return packSpec + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 包装规格 + 型号  + 生产厂家
        return packSpec + '/' + model + tenantSupplierName
      } else {
        // 包装规格 + 生产厂家
        return packSpec + '/' + tenantSupplierName
      }
    } else {
      if (materialsCategory == '0') {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 剂型 + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 型号 + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + model + tenantSupplierName
      } else {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + tenantSupplierName
      }
    }
  }


  return [
    {
      title: flag == 1 ? '药品信息' : '诊疗信息',
      key: 'name',
      render: function MaterialName(_, m): ReactElement {
        return (
          <Col style={{ cursor: 'pointer' }}>
            <div
              style={{
                width: 420,
                color: theme.tc1,
                fontSize: '1.125rem',
                fontWeight: 'bold',
              }}
            >
              {m.name}
            </div>
            <div
              title={getProcuctInfo(m)}
              style={{
                width: 420,
                color: theme.tc2,
                fontSize: '1rem',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {getProcuctInfo(m)}
            </div>
          </Col>
          // </Popover>
        )
      },
    },
    {
      title: '单价/元',
      dataIndex: 'retailPrice',
      align: 'right',
    },
  ]
}
